<template>
	<div class="register">
		<!-- Schools -->
		<div v-if="page===0" class="register__content register__schools">
			<div
				class="register__school"
				:key="school.id"
				v-for="school in schools"
				@click="chooseSchool(school)">
				<h2>{{school.name}}</h2>
			</div>
		</div>
		<!-- Programs -->
		<div v-if="page===1" class="register__content register__programs">
			<div
				class="register__program"
				:key="program.id"
				v-for="program in programs"
				@click="chooseProgram(program)">
				<Icon
					:icon="program.icon">
				</Icon>
				<h2 class="register__program__title">{{program.title}}</h2>
			</div>
		</div>
		<!-- Courses -->
		<div v-if="page===2" class="register__content register__courses">
			<div class="register__courses__years">
				<button
					class="register__courses__year"
					@click="active_year = year"
					:key="'year' + year"
					v-for="year in years">
					Year {{year}}
				</button>
			</div>
			<div
				:key="'period' + period"
				v-for="period in periods">
				<h2 class="register__courses__period">Period {{period}}</h2>
				<div>
					<div
						@click="chooseCourse(course)"
						class="register__course"
						:key="course.id"
						v-for="course in getPeriodCourses(period, yearCourses)">
						<Icon
							:icon="course.icon">
						</Icon>
						<h3 class="register__course__title">{{course.title}}</h3>
						<span class="register__course__selected">
							<i v-if="course.selected" class="far fa-check-circle"></i>
							<i v-else class="far fa-circle"></i>
						</span>
					</div>
				</div>
			</div>
		</div>
		<div v-if="page===3" class="register__content register__form">
			<h1 class="register__form__title">Register</h1>
			<Alert
				v-if="alert_message"
				class="register__form__alert"
				:message="alert_message">
			</Alert>
			<form
				@submit.prevent="register">
				<label class="register__form__label" for="stipt_first-name">First name</label>
				<br>
				<input
					class="register__form__input register__form__input--first-name"
					type="text"
					name="stipt_first-name"
					v-model="user.first_name"/>
				<br>
				<label class="register__form__label" for="stipt_last-name">Last name</label>
				<br>
				<input
					class="register__form__input register__form__input--last-name"
					type="text"
					name="stipt_last-name"
					v-model="user.last_name"/>
				<br>
				<label class="register__form__label" for="stipt_username">Username</label>
				<br>
				<input
					class="register__form__input register__form__input--username"
					type="text"
					name="stipt_username"
					v-model="user.username"/>
				<br>
				<label class="register__form__label" for="stipt_email">E-mail</label>
				<br>
				<input
					class="register__form__input register__form__input--email"
					type="email"
					name="stipt_email"
					v-model="user.email"/>
				<br>
				<label class="register__form__label" for="stipt_password">Password</label>
				<br>
				<input
					class="register__form__input register__form__input--password"
					type="password"
					name="stipt_password"
					v-model="user.password"/>
				<br>
				<label class="register__form__label" for="stipt_password-confirm">Confirm password</label>
				<br>
				<input
					class="register__form__input register__form__input--password-confirm"
					type="password"
					name="stipt_password-confirm"
					v-model="user.password_confirm"/>
				<br>
				<button class="register__form__submit" type="submit">Register</button>
			</form>
		</div>
		<!-- These are the page switch buttons, which we hardcode out for now.
		<button class="register__adjacent" v-if="page > 0" @click="previousPage">Previous</button>
		<button class="register__adjacent" v-if="page > 1 && page < 3" @click="nextPage">Next</button>
		-->
	</div>
</template>

<script>
import AuthenticationService from '@/services/AuthenticationService'
import SchoolService from '@/services/SchoolService'
import Alert from '@/components/Alert'
import Icon from '@/components/Icon.vue'
export default {
	components: {
		Alert,
		Icon
	},
	data () {
		return {
			page: 3, // Hardcode to skip school/program selection for now.
			user: {},
			schools: [],
			programs: [],
			courses: [],
			active_year: 1,
			alert_message: ''
		}
	},
	methods: {
		previousPage () {
			this.page = Math.max(0, this.page - 1)
		},
		nextPage () {
			this.page = Math.min(3, this.page + 1)
		},
		async register () {
			try {
				// Client side validation
				if (this.user.password.length < 6) throw new Error('Password should be at least 6 characters.')
				if (this.user.password !== this.user.password_confirm) throw new Error('Passwords do not match.')
				const response = await AuthenticationService.register({
					first_name: this.user.first_name,
					last_name: this.user.last_name,
					username: this.user.username,
					email: this.user.email,
					password: this.user.password,
					program: this.user.program ? this.user.program.id : null,
					courses: this.chosenCourses
				})
				if (!response.data.success) throw new Error('Something went wrong!')
				// Redirect to the homepage
				this.$router.push({ path: '/login?registered=true' })
			} catch (err) {
				this.alert_message = err.message
			}
		},
		async chooseSchool (school) {
			this.user.school = school
			var programs = await SchoolService.getPrograms(school.id)
			this.programs = programs
			this.nextPage()
		},
		async chooseProgram (program) {
			this.user.program = program
			var courses = await SchoolService.getCourses(program.id)
			courses.forEach(function (course) {
				course.selected = false
			})
			this.courses = courses
			this.nextPage()
		},
		chooseCourse (course) {
			course.selected = !course.selected
		},
		getPeriodCourses (period, courses) {
			return SchoolService.getPeriodCourses(period, this.yearCourses)
		}
	},
	computed: {
		yearCourses () {
			return SchoolService.getYearCourses(this.active_year, this.courses)
		},
		years () {
			return SchoolService.getCourseYears(this.courses)
		},
		periods () {
			return SchoolService.getCoursePeriods(this.yearCourses)
		},
		chosenCourses () {
			const courses = this.courses
			const chosenCourses = courses.filter(course => course.selected)
			return chosenCourses
		}
	},
	mounted () {
	},
	async created () {
		this.schools = await SchoolService.getSchools()
	}
}
</script>

<style lang="scss" scoped>
@import '@/styles/views/_register.scss'
</style>
